import Logo from "@/components/Logo";
import { Mail, Phone } from "lucide-react";
import { WhatsAppIcon } from "@/components/WhatsApp";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#0F172A] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-7">
            <Logo size="lg" variant="light" />
            <p className="mt-6 text-white/65 text-sm max-w-md leading-relaxed">
              Smart Digi is a display-systems engineering practice for LED and LCD hardware,
              digital signage, and broadcast content — deployed and maintained by an in-house team.
            </p>
          </div>
          <div className="lg:col-span-5">
            <div className="text-[12px] uppercase tracking-widest font-semibold text-white/70 mb-4">Get in touch</div>
            <div className="space-y-3">
              <FooterLine icon={Mail} text="akshay@smartdigi.in" href="mailto:akshay@smartdigi.in" />
              <FooterLine icon={Phone} text="+91 98184 82197" href="tel:+919818482197" />
              <FooterLine icon={WhatsAppIcon} text="WhatsApp chat" href="https://wa.me/919818482197" external />
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-xs text-white/45">
            © {new Date().getFullYear()} Smart Digi LED Systems. All rights reserved.
          </div>
          <div className="text-xs text-white/45">
            Display · Signage · DOOH
          </div>
        </div>
      </div>
    </footer>
  );
};

const FooterLine = ({ icon: Icon, text, href, external }) => {
  const Wrapper = href ? "a" : "div";
  const extraProps = external ? { target: "_blank", rel: "noopener noreferrer" } : {};
  return (
    <Wrapper href={href} {...extraProps} className="flex items-center gap-3 text-sm text-white/70 hover:text-white transition">
      <Icon size={15} className="text-white/50" />
      {text}
    </Wrapper>
  );
};

export default Footer;
